import styled from 'styled-components'
import { CardSkeleton } from '../../../../../components/Card/styles'

export const WrapperCards = styled.div``

export const StyledCard = styled.div`
  display: flex;
  height: 100%;
  margin-bottom: 16px;

  ${CardSkeleton} {
    width: 100%;
  }
`
